// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"346":"b19c92b2","764":"0743bd2f","915":"1515765a"}[chunkId] + ".chunk.css";
};